module.exports = __webpack_public_path__ + "assets/e0b7565a00db2bbe50719a1435b8f4bf.png";